import React from 'react';

const Hajun = () => {
  return <h1>Hi</h1>;
};

export default Hajun;
